import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-channel-track',
  templateUrl: './channel-track.component.html',
  styleUrls: ['./channel-track.component.scss'],
})
export class ChannelTrackComponent implements OnInit {
  @Input() config: any;
  @Input() cardName: string = '';
  constructor() {}

  ngOnInit(): void {}
}
